enum ReducerActions {
  Add = 'add',
  Update = 'update',
  Delete = 'delete',
  Replace = 'replace',
  UpdateWithDifferentId = 'updateWithDifferentId',
}

export default ReducerActions;
